/* eslint-disable */
/**
 * Important: Since this file has been generated by js-routes Gem, we will disable ESLint for the
 * file and won't try to improve its syntax. This could cause some unexepcted issues.
 */

/**
 * File generated by js-routes 2.2.8
 * Based on Rails 6.1.7.8 routes of FrontEnd::Application
 */
// eslint-disable-next-line
const __jsr = (
  // eslint-disable-next-line
  () => {
      const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
      let NodeTypes;
      (function (NodeTypes) {
          NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
          NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
          NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
          NodeTypes[NodeTypes["OR"] = 4] = "OR";
          NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
          NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
          NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
          NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
      })(NodeTypes || (NodeTypes = {}));
      const isBrowser = typeof window !== "undefined";
      const UnescapedSpecials = "-._~!$&'()*+,;=:@/"
          .split("")
          .map((s) => s.charCodeAt(0));
      const UnescapedRanges = [
          ["a", "z"],
          ["A", "Z"],
          ["0", "9"],
      ].map((range) => range.map((s) => s.charCodeAt(0)));
      const ModuleReferences = {
          CJS: {
              define(routes) {
                  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  module.exports = routes;
              },
              isSupported() {
                  return typeof module === "object";
              },
          },
          AMD: {
              define(routes) {
                  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  define([], function () {
                      return routes;
                  });
              },
              isSupported() {
                  return typeof define === "function" && !!define.amd;
              },
          },
          UMD: {
              define(routes) {
                  if (ModuleReferences.AMD.isSupported()) {
                      ModuleReferences.AMD.define(routes);
                  }
                  else {
                      if (ModuleReferences.CJS.isSupported()) {
                          try {
                              ModuleReferences.CJS.define(routes);
                          }
                          catch (error) {
                              if (error.name !== "TypeError")
                                  throw error;
                          }
                      }
                  }
              },
              isSupported() {
                  return (ModuleReferences.AMD.isSupported() ||
                      ModuleReferences.CJS.isSupported());
              },
          },
          ESM: {
              define() {
                  // Module can only be defined using ruby code generation
              },
              isSupported() {
                  // Its impossible to check if "export" keyword is supported
                  return true;
              },
          },
          NIL: {
              define() {
                  // Defined using const __jsr =
              },
              isSupported() {
                  return true;
              },
          },
          DTS: {
              // Acts the same as ESM
              define(routes) {
                  ModuleReferences.ESM.define(routes);
              },
              isSupported() {
                  return ModuleReferences.ESM.isSupported();
              },
          },
      };
      class ParametersMissing extends Error {
          constructor(...keys) {
              super(`Route missing required keys: ${keys.join(", ")}`);
              this.keys = keys;
              Object.setPrototypeOf(this, Object.getPrototypeOf(this));
              this.name = ParametersMissing.name;
          }
      }
      const ReservedOptions = [
          "anchor",
          "trailing_slash",
          "subdomain",
          "host",
          "port",
          "protocol",
      ];
      class UtilsClass {
          constructor() {
              this.configuration = {
                  prefix: "",
                  default_url_options: {},
                  special_options_key: "_options",
                  serializer: null || this.default_serializer.bind(this),
              };
          }
          default_serializer(value, prefix) {
              if (this.is_nullable(value)) {
                  return "";
              }
              if (!prefix && !this.is_object(value)) {
                  throw new Error("Url parameters should be a javascript hash");
              }
              prefix = prefix || "";
              const result = [];
              if (this.is_array(value)) {
                  for (const element of value) {
                      result.push(this.default_serializer(element, prefix + "[]"));
                  }
              }
              else if (this.is_object(value)) {
                  for (let key in value) {
                      if (!hasProp(value, key))
                          continue;
                      let prop = value[key];
                      if (this.is_nullable(prop) && prefix) {
                          prop = "";
                      }
                      if (this.is_not_nullable(prop)) {
                          if (prefix) {
                              key = prefix + "[" + key + "]";
                          }
                          result.push(this.default_serializer(prop, key));
                      }
                  }
              }
              else {
                  if (this.is_not_nullable(value)) {
                      result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                  }
              }
              return result.join("&");
          }
          serialize(object) {
              return this.configuration.serializer(object);
          }
          extract_options(number_of_params, args) {
              const last_el = args[args.length - 1];
              if ((args.length > number_of_params && last_el === 0) ||
                  (this.is_object(last_el) &&
                      !this.looks_like_serialized_model(last_el))) {
                  if (this.is_object(last_el)) {
                      delete last_el[this.configuration.special_options_key];
                  }
                  return {
                      args: args.slice(0, args.length - 1),
                      options: last_el,
                  };
              }
              else {
                  return { args, options: {} };
              }
          }
          looks_like_serialized_model(object) {
              return (this.is_object(object) &&
                  !(this.configuration.special_options_key in object) &&
                  ("id" in object || "to_param" in object || "toParam" in object));
          }
          path_identifier(object) {
              const result = this.unwrap_path_identifier(object);
              return this.is_nullable(result) ||
                  (true &&
                      result === false)
                  ? ""
                  : "" + result;
          }
          unwrap_path_identifier(object) {
              let result = object;
              if (!this.is_object(object)) {
                  return object;
              }
              if ("to_param" in object) {
                  result = object.to_param;
              }
              else if ("toParam" in object) {
                  result = object.toParam;
              }
              else if ("id" in object) {
                  result = object.id;
              }
              else {
                  result = object;
              }
              return this.is_callable(result) ? result.call(object) : result;
          }
          partition_parameters(parts, required_params, default_options, call_arguments) {
              // eslint-disable-next-line prefer-const
              let { args, options } = this.extract_options(parts.length, call_arguments);
              if (args.length > parts.length) {
                  throw new Error("Too many parameters provided for path");
              }
              let use_all_parts = args.length > required_params.length;
              const parts_options = {
                  ...this.configuration.default_url_options,
              };
              for (const key in options) {
                  const value = options[key];
                  if (!hasProp(options, key))
                      continue;
                  use_all_parts = true;
                  if (parts.includes(key)) {
                      parts_options[key] = value;
                  }
              }
              options = {
                  ...this.configuration.default_url_options,
                  ...default_options,
                  ...options,
              };
              const keyword_parameters = {};
              let query_parameters = {};
              for (const key in options) {
                  if (!hasProp(options, key))
                      continue;
                  const value = options[key];
                  if (key === "params") {
                      if (this.is_object(value)) {
                          query_parameters = {
                              ...query_parameters,
                              ...value,
                          };
                      }
                      else {
                          throw new Error("params value should always be an object");
                      }
                  }
                  else if (this.is_reserved_option(key)) {
                      keyword_parameters[key] = value;
                  }
                  else {
                      if (!this.is_nullable(value) &&
                          (value !== default_options[key] || required_params.includes(key))) {
                          query_parameters[key] = value;
                      }
                  }
              }
              const route_parts = use_all_parts ? parts : required_params;
              let i = 0;
              for (const part of route_parts) {
                  if (i < args.length) {
                      const value = args[i];
                      if (!hasProp(parts_options, part)) {
                          query_parameters[part] = value;
                          ++i;
                      }
                  }
              }
              return { keyword_parameters, query_parameters };
          }
          build_route(parts, required_params, default_options, route, absolute, args) {
              const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
              const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                  this.is_nullable(query_parameters[param]));
              if (missing_params.length) {
                  throw new ParametersMissing(...missing_params);
              }
              let result = this.get_prefix() + this.visit(route, query_parameters);
              if (keyword_parameters.trailing_slash) {
                  result = result.replace(/(.*?)[/]?$/, "$1/");
              }
              const url_params = this.serialize(query_parameters);
              if (url_params.length) {
                  result += "?" + url_params;
              }
              result += keyword_parameters.anchor
                  ? "#" + keyword_parameters.anchor
                  : "";
              if (absolute) {
                  result = this.route_url(keyword_parameters) + result;
              }
              return result;
          }
          visit(route, parameters, optional = false) {
              switch (route[0]) {
                  case NodeTypes.GROUP:
                      return this.visit(route[1], parameters, true);
                  case NodeTypes.CAT:
                      return this.visit_cat(route, parameters, optional);
                  case NodeTypes.SYMBOL:
                      return this.visit_symbol(route, parameters, optional);
                  case NodeTypes.STAR:
                      return this.visit_globbing(route[1], parameters, true);
                  case NodeTypes.LITERAL:
                  case NodeTypes.SLASH:
                  case NodeTypes.DOT:
                      return route[1];
                  default:
                      throw new Error("Unknown Rails node type");
              }
          }
          is_not_nullable(object) {
              return !this.is_nullable(object);
          }
          is_nullable(object) {
              return object === undefined || object === null;
          }
          visit_cat(
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          [_type, left, right], parameters, optional) {
              const left_part = this.visit(left, parameters, optional);
              let right_part = this.visit(right, parameters, optional);
              if (optional &&
                  ((this.is_optional_node(left[0]) && !left_part) ||
                      (this.is_optional_node(right[0]) && !right_part))) {
                  return "";
              }
              // if left_part ends on '/' and right_part starts on '/'
              if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                  // strip slash from right_part
                  // to prevent double slash
                  right_part = right_part.substring(1);
              }
              return left_part + right_part;
          }
          visit_symbol(
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          [_type, key], parameters, optional) {
              const value = this.path_identifier(parameters[key]);
              delete parameters[key];
              if (value.length) {
                  return this.encode_segment(value);
              }
              if (optional) {
                  return "";
              }
              else {
                  throw new ParametersMissing(key);
              }
          }
          encode_segment(segment) {
              if (segment.match(/^[a-zA-Z0-9-]$/)) {
                  // Performance optimization for 99% of cases
                  return segment;
              }
              return (segment.match(/./gu) || [])
                  .map((ch) => {
                  const code = ch.charCodeAt(0);
                  if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                      UnescapedSpecials.includes(code)) {
                      return ch;
                  }
                  else {
                      return encodeURIComponent(ch);
                  }
              })
                  .join("");
          }
          is_optional_node(node) {
              return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
          }
          build_path_spec(route, wildcard = false) {
              let key;
              switch (route[0]) {
                  case NodeTypes.GROUP:
                      return `(${this.build_path_spec(route[1])})`;
                  case NodeTypes.CAT:
                      return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                  case NodeTypes.STAR:
                      return this.build_path_spec(route[1], true);
                  case NodeTypes.SYMBOL:
                      key = route[1];
                      if (wildcard) {
                          return (key.startsWith("*") ? "" : "*") + key;
                      }
                      else {
                          return ":" + key;
                      }
                      break;
                  case NodeTypes.SLASH:
                  case NodeTypes.DOT:
                  case NodeTypes.LITERAL:
                      return route[1];
                  default:
                      throw new Error("Unknown Rails node type");
              }
          }
          visit_globbing(route, parameters, optional) {
              const key = route[1];
              let value = parameters[key];
              delete parameters[key];
              if (this.is_nullable(value)) {
                  return this.visit(route, parameters, optional);
              }
              if (this.is_array(value)) {
                  value = value.join("/");
              }
              const result = this.path_identifier(value);
              return false
                  ? result
                  : encodeURI(result);
          }
          get_prefix() {
              const prefix = this.configuration.prefix;
              return prefix.match("/$")
                  ? prefix.substring(0, prefix.length - 1)
                  : prefix;
          }
          route(parts_table, route_spec, absolute = false) {
              const required_params = [];
              const parts = [];
              const default_options = {};
              for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                  parts.push(part);
                  if (required) {
                      required_params.push(part);
                  }
                  if (this.is_not_nullable(value)) {
                      default_options[part] = value;
                  }
              }
              const result = (...args) => {
                  return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
              };
              result.requiredParams = () => required_params;
              result.toString = () => {
                  return this.build_path_spec(route_spec);
              };
              return result;
          }
          route_url(route_defaults) {
              const hostname = route_defaults.host || this.current_host();
              if (!hostname) {
                  return "";
              }
              const subdomain = route_defaults.subdomain
                  ? route_defaults.subdomain + "."
                  : "";
              const protocol = route_defaults.protocol || this.current_protocol();
              let port = route_defaults.port ||
                  (!route_defaults.host ? this.current_port() : undefined);
              port = port ? ":" + port : "";
              return protocol + "://" + subdomain + hostname + port;
          }
          current_host() {
              var _a;
              return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
          }
          current_protocol() {
              var _a, _b;
              return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
          }
          current_port() {
              var _a;
              return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
          }
          is_object(value) {
              return (typeof value === "object" &&
                  Object.prototype.toString.call(value) === "[object Object]");
          }
          is_array(object) {
              return object instanceof Array;
          }
          is_callable(object) {
              return typeof object === "function" && !!object.call;
          }
          is_reserved_option(key) {
              return ReservedOptions.includes(key);
          }
          configure(new_config) {
              this.configuration = { ...this.configuration, ...new_config };
              return this.configuration;
          }
          config() {
              return { ...this.configuration };
          }
          is_module_supported(name) {
              return ModuleReferences[name].isSupported();
          }
          ensure_module_supported(name) {
              if (!this.is_module_supported(name)) {
                  throw new Error(`${name} is not supported by runtime`);
              }
          }
          define_module(name, module) {
              this.ensure_module_supported(name);
              ModuleReferences[name].define(module);
          }
      }
      const Utils = new UtilsClass();
      // We want this helper name to be short
      const __jsr = {
          r(parts_table, route_spec, absolute) {
              return Utils.route(parts_table, route_spec, absolute);
          },
      };
      const result = {
          ...__jsr,
          configure: (config) => {
              return Utils.configure(config);
          },
          config: () => {
              return Utils.config();
          },
          serialize: (object) => {
              return Utils.serialize(object);
          },
          ...{},
      };
      Utils.define_module("ESM", result);
      return result;
  })();
  export const configure = __jsr.configure;

  export const config = __jsr.config;

  export const serialize = __jsr.serialize;

  /**
   * Generates rails route to
   * /account(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /account/users(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const account_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /profile/activate(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const activate_profile_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /jobs/:id/add_to_favorites(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const add_to_favorites_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_to_favorites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/cache_keys/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_cache_key_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cache_keys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/focus_areas/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"focus_areas"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/focus_areas(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"focus_areas"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /admin/companies(/*react_route)(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_companies_path = /*#__PURE__*/ __jsr.r({"react_route":{},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[1,[2,[7,"/"],[5,[3,"react_route"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/dashboard(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_dashboard_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_development_data_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/automation_dashboard(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_development_data_automation_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"automation_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/contracts/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_development_data_contract_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/contracts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_development_data_contracts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"contracts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/donors(/*react_route)(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_development_data_donors_path = /*#__PURE__*/ __jsr.r({"react_route":{},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"donors"],[2,[1,[2,[7,"/"],[5,[3,"react_route"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/grants/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_development_data_grant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"grants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/grants(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_development_data_grants_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"grants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/open_opportunities(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_development_data_open_opportunities_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"open_opportunities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/open_opportunities/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_development_data_open_opportunity_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"open_opportunities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/organizations/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_development_data_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/organizations/:organization_id/company_links/:id(.:format)
   * @param {any} organization_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_development_data_organization_company_link_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"company_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/organizations/:organization_id/company_links(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_development_data_organization_company_links_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"company_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/organizations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_development_data_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/pipelines/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_development_data_pipeline_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"pipelines"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/pipelines(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_development_data_pipelines_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"pipelines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/raw_funding_infos/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_development_data_raw_funding_info_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"raw_funding_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/raw_funding_infos(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_development_data_raw_funding_infos_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"raw_funding_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/scrape_runs/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_development_data_scrape_run_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"scrape_runs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/scrape_runs(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_development_data_scrape_runs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"scrape_runs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/search(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_development_data_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/tenders/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_development_data_tender_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"tenders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/tenders(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_development_data_tenders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"tenders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/tools(/*react_route)(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_development_data_tools_path = /*#__PURE__*/ __jsr.r({"react_route":{},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"tools"],[2,[1,[2,[7,"/"],[5,[3,"react_route"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/downloadables(/*react_route)(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_downloadables_path = /*#__PURE__*/ __jsr.r({"react_route":{},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"downloadables"],[2,[1,[2,[7,"/"],[5,[3,"react_route"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/events(/*react_route)(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_events_path = /*#__PURE__*/ __jsr.r({"react_route":{},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"events"],[2,[1,[2,[7,"/"],[5,[3,"react_route"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/funding(/*react_route)(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_funding_path = /*#__PURE__*/ __jsr.r({"react_route":{},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"funding"],[2,[1,[2,[7,"/"],[5,[3,"react_route"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/jobs/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/jobs(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_jobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /admin/landing_pages/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_landing_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"landing_pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/landing_pages(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_landing_pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"landing_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /admin/news_lab/articles/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_news_lab_article_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"news_lab"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/news_lab/articles/:article_id/assign_google_doc(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_news_lab_article_assign_google_doc_path = /*#__PURE__*/ __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"news_lab"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"assign_google_doc"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/news_lab/articles(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_news_lab_articles_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"news_lab"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/news_lab/content(/*react_route)(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_news_lab_content_path = /*#__PURE__*/ __jsr.r({"react_route":{},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"news_lab"],[2,[7,"/"],[2,[6,"content"],[2,[1,[2,[7,"/"],[5,[3,"react_route"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/news_lab/events(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_news_lab_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"news_lab"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/news_lab/google/documents/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_news_lab_google_document_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"news_lab"],[2,[7,"/"],[2,[6,"google"],[2,[7,"/"],[2,[6,"documents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/news_lab/partners(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_news_lab_partners_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"news_lab"],[2,[7,"/"],[2,[6,"partners"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/news_lab(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_news_lab_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"news_lab"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /admin/newsletters/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_newsletter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/newsletters(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_newsletters_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"newsletters"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /admin/payment_pages/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_payment_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payment_pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/payment_pages/:payment_page_id/items/:id(.:format)
   * @param {any} payment_page_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_payment_page_item_path = /*#__PURE__*/ __jsr.r({"payment_page_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payment_pages"],[2,[7,"/"],[2,[3,"payment_page_id"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/payment_pages/:payment_page_id/items(.:format)
   * @param {any} payment_page_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_payment_page_items_path = /*#__PURE__*/ __jsr.r({"payment_page_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payment_pages"],[2,[7,"/"],[2,[3,"payment_page_id"],[2,[7,"/"],[2,[6,"items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/payment_pages(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_payment_pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payment_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /admin/permissions(/*react_route)(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_permissions_path = /*#__PURE__*/ __jsr.r({"react_route":{},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"permissions"],[2,[1,[2,[7,"/"],[5,[3,"react_route"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/procurement/shortlists/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_procurement_shortlist_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"shortlists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/procurement/shortlists(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_procurement_shortlists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"shortlists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /admin/story_types/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_story_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"story_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/story_types(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_story_types_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"story_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /admin/users/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/users/:user_id/switch(.:format)
   * @param {any} user_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_user_switch_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"switch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/users(/*react_route)(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const admin_users_path = /*#__PURE__*/ __jsr.r({"react_route":{},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[1,[2,[7,"/"],[5,[3,"react_route"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

  /**
   * Generates rails route to
   * /api/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/analytics/activities(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_activities_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/analytics/job_applications(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_analytics_job_applications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"job_applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/autocomplete/:object.json(.:format)
   * @param {any} object
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_autocomplete_path = /*#__PURE__*/ __jsr.r({"object":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"autocomplete"],[2,[7,"/"],[2,[3,"object"],[2,[8,"."],[2,[6,"json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/autocomplete/jobs/employer_companies.json(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_autocomplete_jobs_employer_companies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"autocomplete"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"employer_companies"],[2,[8,"."],[2,[6,"json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/autocomplete/locations.json(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_autocomplete_locations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"autocomplete"],[2,[7,"/"],[2,[6,"locations"],[2,[8,"."],[2,[6,"json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/autocomplete/places.json(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_autocomplete_places_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"autocomplete"],[2,[7,"/"],[2,[6,"places"],[2,[8,"."],[2,[6,"json"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/autocomplete/projects_by_reference_number(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_autocomplete_projects_by_reference_number_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"autocomplete"],[2,[7,"/"],[2,[6,"projects_by_reference_number"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/current_user/bookmarked_searches/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_bookmarked_search_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"current_user"],[2,[7,"/"],[2,[6,"bookmarked_searches"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/consultants/:id/request_cv(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_consultant_request_cv_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"consultants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"request_cv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/consultants/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_consultants_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"consultants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/search/consultants(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_consultants_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"consultants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/contents/events(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_content_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"contents"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/current_user(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_current_user_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"current_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/current_user/addresses(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_current_user_addresses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"current_user"],[2,[7,"/"],[2,[6,"addresses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/current_user/associations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_current_user_associations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"current_user"],[2,[7,"/"],[2,[6,"associations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/current_user/credits/SEND_MESSAGES(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_current_user_credits_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"current_user"],[2,[7,"/"],[2,[6,"credits"],[2,[7,"/"],[2,[6,"SEND_MESSAGES"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/current_user/documents(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_current_user_documents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"current_user"],[2,[7,"/"],[2,[6,"documents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/current_user/educations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_current_user_education_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"current_user"],[2,[7,"/"],[2,[6,"educations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/current_user/employments(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_current_user_employments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"current_user"],[2,[7,"/"],[2,[6,"employments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/current_user/links(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_current_user_links_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"current_user"],[2,[7,"/"],[2,[6,"links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/current_user/message_handlers(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_current_user_messengers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"current_user"],[2,[7,"/"],[2,[6,"message_handlers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/current_user/message_handlers/bulk(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_current_user_messengers_bulk_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"current_user"],[2,[7,"/"],[2,[6,"message_handlers"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/current_user/newsletters(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_current_user_newsletters_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"current_user"],[2,[7,"/"],[2,[6,"newsletters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/current_user/notes(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_current_user_notes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"current_user"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/current_user/photos(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_current_user_photos_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"current_user"],[2,[7,"/"],[2,[6,"photos"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/current_user/profile_views(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_current_user_profile_views_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"current_user"],[2,[7,"/"],[2,[6,"profile_views"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/current_user/references(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_current_user_references_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"current_user"],[2,[7,"/"],[2,[6,"references"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/current_user/resumes(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_current_user_resumes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"current_user"],[2,[7,"/"],[2,[6,"resumes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/current_user/taggings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_current_user_taggings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"current_user"],[2,[7,"/"],[2,[6,"taggings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/current_user/tags(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_current_user_tags_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"current_user"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/current_user/tracked_reports(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_current_user_tracked_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"current_user"],[2,[7,"/"],[2,[6,"tracked_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/current_user/favorites(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_favorites_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"current_user"],[2,[7,"/"],[2,[6,"favorites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/analytics/development_data/graph_data/posted_in_the_past(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_graph_data_posted_in_the_past_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"graph_data"],[2,[7,"/"],[2,[6,"posted_in_the_past"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/jobs/applications_count(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_jobs_application_count_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"applications_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/search/jobs(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_jobs_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /apps/front_end/api/keywords/:keyword(.:format)
   * @param {any} keyword
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_keywords_path = /*#__PURE__*/ __jsr.r({"keyword":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"front_end"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"keywords"],[2,[7,"/"],[2,[3,"keyword"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /apps/front_end/api/news/articles/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_news_article_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"front_end"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /apps/front_end/api/news/articles(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_news_articles_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"front_end"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /apps/front_end/api/news/google/docs(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_news_google_docs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"front_end"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"google"],[2,[7,"/"],[2,[6,"docs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/search/articles(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_news_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/procurements/reports/:report_type/:report_id/contact(.:format)
   * @param {any} report_type
   * @param {any} report_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_procurements_contact_partner_path = /*#__PURE__*/ __jsr.r({"report_type":{"r":true},"report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"procurements"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"report_type"],[2,[7,"/"],[2,[3,"report_id"],[2,[7,"/"],[2,[6,"contact"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/current_user/request_cv_recipients(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_request_cv_recipients_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"current_user"],[2,[7,"/"],[2,[6,"request_cv_recipients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/current_user/request_cv_recipients/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_request_cv_recipients_delete_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"current_user"],[2,[7,"/"],[2,[6,"request_cv_recipients"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/search/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_search_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /apps/front_end/api/system/health(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_system_health_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"front_end"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"system"],[2,[7,"/"],[2,[6,"health"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/analytics/views/:content_type/ranking(.:format)
   * @param {any} content_type
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const api_views_path = /*#__PURE__*/ __jsr.r({"content_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"views"],[2,[7,"/"],[2,[3,"content_type"],[2,[7,"/"],[2,[6,"ranking"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /jobs/:id/apply_externally(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const apply_externally_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apply_externally"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /jobs/:id/applications/:application_id/apply(.:format)
   * @param {any} id
   * @param {any} application_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const apply_job_application_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"application_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"apply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /account/billing(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const billing_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /ui_expo/bootstrap_5(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const bootstrap_5_expo_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ui_expo"],[2,[7,"/"],[2,[6,"bootstrap_5"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/raw_funding_infos/bulk_confirm(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const bulk_confirm_admin_development_data_raw_funding_infos_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"raw_funding_infos"],[2,[7,"/"],[2,[6,"bulk_confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /campaigns/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /campaigns(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /career-center(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const career_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"career-center"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /organizations/:slug_and_id/careers(.:format)
   * @param {any} slug_and_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const careers_organization_path = /*#__PURE__*/ __jsr.r({"slug_and_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"slug_and_id"],[2,[7,"/"],[2,[6,"careers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /change_password(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const change_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"change_password"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /organizations/:slug_and_id/changes(.:format)
   * @param {any} slug_and_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const changes_organization_path = /*#__PURE__*/ __jsr.r({"slug_and_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"slug_and_id"],[2,[7,"/"],[2,[6,"changes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /apps/front_end/api/form_inputs/check_email(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const check_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"front_end"],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"form_inputs"],[2,[7,"/"],[2,[6,"check_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/contracts/:id/claim(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const claim_admin_development_data_contract_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"claim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/funding_infos/:id/claim(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const claim_admin_development_data_funding_info_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"funding_infos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"claim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/grants/:id/claim(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const claim_admin_development_data_grant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"grants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"claim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/jobs/:id/claim(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const claim_admin_development_data_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"claim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/open_opportunities/:id/claim(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const claim_admin_development_data_open_opportunity_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"open_opportunities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"claim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/pipelines/:id/claim(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const claim_admin_development_data_pipeline_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"pipelines"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"claim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/tenders/:id/claim(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const claim_admin_development_data_tender_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"tenders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"claim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/procurement/shortlists/:id/claim(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const claim_admin_procurement_shortlist_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"shortlists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"claim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/cache_keys/clear_user_account_level_cache(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const clear_user_account_level_cache_admin_cache_keys_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cache_keys"],[2,[7,"/"],[2,[6,"clear_user_account_level_cache"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /news/lab/comment(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const comment_save_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"lab"],[2,[7,"/"],[2,[6,"comment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /profile/confirm_data(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const confirm_data_profile_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"confirm_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /organizations/:slug_and_id/contacts(.:format)
   * @param {any} slug_and_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const contacts_organization_path = /*#__PURE__*/ __jsr.r({"slug_and_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"slug_and_id"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /content-series(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const content_series_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"content-series"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /funding/contracts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const contracts_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"contracts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /jobs/:id/delete(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const delete_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /messages/delete_template/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const delete_message_template_messages_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"delete_template"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /focus/devpros-2030(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const devpros_2030_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"focus"],[2,[7,"/"],[2,[6,"devpros-2030"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /downloadables/:slug_and_id(.:format)
   * @param {any} slug_and_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const downloadable_path = /*#__PURE__*/ __jsr.r({"slug_and_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"downloadables"],[2,[7,"/"],[2,[3,"slug_and_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /admin/focus_areas/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const edit_admin_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"focus_areas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/contracts/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const edit_admin_development_data_contract_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/grants/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const edit_admin_development_data_grant_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"grants"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/open_opportunities/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const edit_admin_development_data_open_opportunity_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"open_opportunities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/organizations/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const edit_admin_development_data_organization_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/organizations/:organization_id/company_links/:id/edit(.:format)
   * @param {any} organization_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const edit_admin_development_data_organization_company_link_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"company_links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/pipelines/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const edit_admin_development_data_pipeline_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"pipelines"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/raw_funding_infos/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const edit_admin_development_data_raw_funding_info_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"raw_funding_infos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/tenders/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const edit_admin_development_data_tender_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"tenders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/jobs/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const edit_admin_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/landing_pages/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const edit_admin_landing_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"landing_pages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/news_lab/articles/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const edit_admin_news_lab_article_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"news_lab"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/newsletters/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const edit_admin_newsletter_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/payment_pages/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const edit_admin_payment_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payment_pages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/payment_pages/:payment_page_id/items/:id/edit(.:format)
   * @param {any} payment_page_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const edit_admin_payment_page_item_path = /*#__PURE__*/ __jsr.r({"payment_page_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payment_pages"],[2,[7,"/"],[2,[3,"payment_page_id"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/procurement/shortlists/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const edit_admin_procurement_shortlist_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"shortlists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/story_types/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const edit_admin_story_type_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"story_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /campaigns/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const edit_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /jobs/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const edit_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /profile/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const edit_profile_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /funding/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const edit_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /funding/tgo/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const edit_projects_tgo_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"tgo"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /register/:package_short_name(/*react_route)(.:format)
   * @param {any} package_short_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const email_registration_path = /*#__PURE__*/ __jsr.r({"package_short_name":{"r":true},"react_route":{},"format":{}}, [2,[7,"/"],[2,[6,"register"],[2,[7,"/"],[2,[3,"package_short_name"],[2,[1,[2,[7,"/"],[5,[3,"react_route"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

  /**
   * Generates rails route to
   * /events/:slug_and_id(.:format)
   * @param {any} slug_and_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const event_path = /*#__PURE__*/ __jsr.r({"slug_and_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[3,"slug_and_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /focus/faith-development(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const faith_development_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"focus"],[2,[7,"/"],[2,[6,"faith-development"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /jobs/:id/feature(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const feature_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"feature"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /jobs/feed(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const feed_jobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"feed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /funding/feed(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const feed_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"feed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /finance(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const finance_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"finance"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /focus-areas(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const focus_areas_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"focus-areas"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /focus/future-of-work(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const focus_future_of_work_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"focus"],[2,[7,"/"],[2,[6,"future-of-work"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /campaigns/:id/follow(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const follow_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"follow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /food(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const food_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"food"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /funding(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const funding_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"funding"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /funding/dashboard(/:id)(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const funding_dashboard_path = /*#__PURE__*/ __jsr.r({"id":{},"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"dashboard"],[2,[1,[2,[7,"/"],[3,"id"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

  /**
   * Generates rails route to
   * /funding/feed(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const funding_feed_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"feed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /funding-overview(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const funding_overview_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"funding-overview"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /funding/r(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const funding_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"r"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /funding-trends(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const funding_trends_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"funding-trends"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /focus/gender-data(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const gender_data_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"focus"],[2,[7,"/"],[2,[6,"gender-data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /funding/grants/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const grant_default_projects_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"grants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /funding/grants/:permalink/:id(.:format)
   * @param {any} permalink
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const grant_projects_path = /*#__PURE__*/ __jsr.r({"permalink":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"grants"],[2,[7,"/"],[2,[3,"permalink"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /health(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const health_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"health"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const home_page_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

  /**
   * Generates rails route to
   * /focus/improving-nutrition(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const improving_nutrition_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"focus"],[2,[7,"/"],[2,[6,"improving-nutrition"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /membership/individuals(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const individual_membership_plans_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"membership"],[2,[7,"/"],[2,[6,"individuals"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /jobs/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /jobs/:id/applications/:application_id(.:format)
   * @param {any} id
   * @param {any} application_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const job_application_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"application_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /jobs/:id/applications(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const job_applications_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /jobs/job-posting-credit-check-and-redirect(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const job_posting_credit_check_and_redirect_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"job-posting-credit-check-and-redirect"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /jobs/posting-options(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const job_posting_options_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"posting-options"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /jobs(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const jobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /login(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const login_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /logout(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const logout_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /membership(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const membership_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"membership"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /membership/professional(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const membership_professional_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"membership"],[2,[7,"/"],[2,[6,"professional"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /membership/professional-annual(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const membership_professional_annual_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"membership"],[2,[7,"/"],[2,[6,"professional-annual"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /membership/professional-membership-discount(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const membership_professional_membership_discount_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"membership"],[2,[7,"/"],[2,[6,"professional-membership-discount"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/organizations/merge(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const merge_admin_development_data_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"merge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /messages(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /jobs/my_applications(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const my_applications_jobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"my_applications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /my-devex(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const my_devex_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"my-devex"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /my-devex/preferences(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const my_devex_preferences_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"my-devex"],[2,[7,"/"],[2,[6,"preferences"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /my-jobs(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const my_jobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"my-jobs"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /my-newsletters(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const my_newsletters_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"my-newsletters"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /admin/focus_areas/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_admin_campaign_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"focus_areas"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/contracts/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_admin_development_data_contract_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/grants/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_admin_development_data_grant_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"grants"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/open_opportunities/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_admin_development_data_open_opportunity_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"open_opportunities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/organizations/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_admin_development_data_organization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/organizations/:organization_id/company_links/new(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_admin_development_data_organization_company_link_path = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"company_links"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/pipelines/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_admin_development_data_pipeline_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"pipelines"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/raw_funding_infos/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_admin_development_data_raw_funding_info_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"raw_funding_infos"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/tenders/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_admin_development_data_tender_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"tenders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/jobs/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_admin_job_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/landing_pages/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_admin_landing_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"landing_pages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/news_lab/articles/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_admin_news_lab_article_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"news_lab"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/news_lab/partners/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_admin_news_lab_partner_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"news_lab"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/newsletters/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_admin_newsletter_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/payment_pages/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_admin_payment_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payment_pages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/payment_pages/:payment_page_id/items/new(.:format)
   * @param {any} payment_page_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_admin_payment_page_item_path = /*#__PURE__*/ __jsr.r({"payment_page_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payment_pages"],[2,[7,"/"],[2,[3,"payment_page_id"],[2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/procurement/shortlists/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_admin_procurement_shortlist_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"procurement"],[2,[7,"/"],[2,[6,"shortlists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/story_types/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_admin_story_type_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"story_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /campaigns/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_campaign_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /jobs/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_job_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /jobs/:id/applications/new(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_job_application_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /messages/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_message_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /organizations/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_organization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /funding/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /funding/tgo/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const new_projects_tgo_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"tgo"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /news/apple_news_feed(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const news_apple_news_feed_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"apple_news_feed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /news/:slug_and_id(.:format)
   * @param {any} slug_and_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const news_article_path = /*#__PURE__*/ __jsr.r({"slug_and_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"slug_and_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /news/:slug_and_id/amp(.:format)
   * @param {any} slug_and_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const news_article_amp_path = /*#__PURE__*/ __jsr.r({"slug_and_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[3,"slug_and_id"],[2,[7,"/"],[2,[6,"amp"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /news/lab/trending(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const news_cmt_trending_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"lab"],[2,[7,"/"],[2,[6,"trending"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /news/feed(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const news_feed_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"feed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /news(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const news_home_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /news/search(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const news_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /news/lab/trending(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const news_trending_create_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"lab"],[2,[7,"/"],[2,[6,"trending"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /news/lab/trending/delete/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const news_trending_delete_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"lab"],[2,[7,"/"],[2,[6,"trending"],[2,[7,"/"],[2,[6,"delete"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /news/lab/trending/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const news_trending_update_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"lab"],[2,[7,"/"],[2,[6,"trending"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /newsletters/:slug(/*react_route)(.:format)
   * @param {any} slug
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const newsletter_signup_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"react_route":{},"format":{}}, [2,[7,"/"],[2,[6,"newsletters"],[2,[7,"/"],[2,[3,"slug"],[2,[1,[2,[7,"/"],[5,[3,"react_route"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

  /**
   * Generates rails route to
   * /account/newsletters(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const newsletters_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"newsletters"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /notes/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const note_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /notes(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const notes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /auth/:provider/callback(.:format)
   * @param {any} provider
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const oauth_callback_path = /*#__PURE__*/ __jsr.r({"provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[3,"provider"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /auth/failure(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const oauth_failure_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"failure"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /projects/search/advanced(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const old_advanced_search_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"advanced"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /projects/search/all(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const old_all_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /projects/search/autocomplete(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const old_autocomplete_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"autocomplete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /projects/dashboard(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const old_dashboard_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /projects/grants/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const old_grant_default_projects_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"grants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /projects/grants/:permalink/:id(.:format)
   * @param {any} permalink
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const old_grant_projects_path = /*#__PURE__*/ __jsr.r({"permalink":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"grants"],[2,[7,"/"],[2,[3,"permalink"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /projects/open_opportunities/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const old_open_opportunity_default_projects_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"open_opportunities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /projects/open_opportunities/:permalink/:id(.:format)
   * @param {any} permalink
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const old_open_opportunity_projects_path = /*#__PURE__*/ __jsr.r({"permalink":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"open_opportunities"],[2,[7,"/"],[2,[3,"permalink"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /projects/pipelines/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const old_pipeline_default_projects_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pipelines"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /projects/pipelines/:permalink/:id(.:format)
   * @param {any} permalink
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const old_pipeline_projects_path = /*#__PURE__*/ __jsr.r({"permalink":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pipelines"],[2,[7,"/"],[2,[3,"permalink"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /projects/pipelines(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const old_pipelines_index_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pipelines"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /projects/pipelines/search(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const old_pipelines_search_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pipelines"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /projects/grants/:permalink/:id/premium(.:format)
   * @param {any} permalink
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const old_premium_grant_projects_path = /*#__PURE__*/ __jsr.r({"permalink":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"grants"],[2,[7,"/"],[2,[3,"permalink"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"premium"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /projects/open_opportunities/:permalink/:id/premium(.:format)
   * @param {any} permalink
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const old_premium_open_opportunity_projects_path = /*#__PURE__*/ __jsr.r({"permalink":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"open_opportunities"],[2,[7,"/"],[2,[3,"permalink"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"premium"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /projects/pipelines/:permalink/:id/premium(.:format)
   * @param {any} permalink
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const old_premium_pipeline_projects_path = /*#__PURE__*/ __jsr.r({"permalink":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"pipelines"],[2,[7,"/"],[2,[3,"permalink"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"premium"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /projects/tenders/:permalink/:id/premium(.:format)
   * @param {any} permalink
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const old_premium_tender_projects_path = /*#__PURE__*/ __jsr.r({"permalink":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"tenders"],[2,[7,"/"],[2,[3,"permalink"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"premium"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /projects(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const old_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /projects/tenders/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const old_tender_default_projects_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"tenders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /projects/tenders/:permalink/:id(.:format)
   * @param {any} permalink
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const old_tender_projects_path = /*#__PURE__*/ __jsr.r({"permalink":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"tenders"],[2,[7,"/"],[2,[3,"permalink"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /projects/tenders-grants(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const old_tgo_index_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"tenders-grants"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /projects/tenders-grants/search(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const old_tgo_search_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"tenders-grants"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /funding/open_opportunities/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const open_opportunity_default_projects_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"open_opportunities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /funding/open_opportunities/:permalink/:id(.:format)
   * @param {any} permalink
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const open_opportunity_projects_path = /*#__PURE__*/ __jsr.r({"permalink":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"open_opportunities"],[2,[7,"/"],[2,[3,"permalink"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /organizations/:slug_and_id(.:format)
   * @param {any} slug_and_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const organization_path = /*#__PURE__*/ __jsr.r({"slug_and_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"slug_and_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /membership/organizations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const organization_membership_plans_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"membership"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /organizations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /jobs/:id/payment(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const payment_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"payment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /people(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const people_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /people/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const person_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /funding/programs/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const pipeline_default_projects_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /funding/programs/:permalink/:id(.:format)
   * @param {any} permalink
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const pipeline_projects_path = /*#__PURE__*/ __jsr.r({"permalink":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"permalink"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /funding/programs(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const pipelines_index_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"programs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /funding/programs/search(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const pipelines_search_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /funding/grants/:permalink/:id/premium(.:format)
   * @param {any} permalink
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const premium_grant_projects_path = /*#__PURE__*/ __jsr.r({"permalink":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"grants"],[2,[7,"/"],[2,[3,"permalink"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"premium"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /funding/open_opportunities/:permalink/:id/premium(.:format)
   * @param {any} permalink
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const premium_open_opportunity_projects_path = /*#__PURE__*/ __jsr.r({"permalink":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"open_opportunities"],[2,[7,"/"],[2,[3,"permalink"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"premium"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /funding/programs/:permalink/:id/premium(.:format)
   * @param {any} permalink
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const premium_pipeline_projects_path = /*#__PURE__*/ __jsr.r({"permalink":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"permalink"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"premium"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /funding/tenders/:permalink/:id/premium(.:format)
   * @param {any} permalink
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const premium_tender_projects_path = /*#__PURE__*/ __jsr.r({"permalink":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"tenders"],[2,[7,"/"],[2,[3,"permalink"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"premium"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /jobs/:id/preview(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const preview_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /organizations/:slug_and_id/preview(.:format)
   * @param {any} slug_and_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const preview_organization_path = /*#__PURE__*/ __jsr.r({"slug_and_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"slug_and_id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /pro(/:discount_code)(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const pro_path = /*#__PURE__*/ __jsr.r({"discount_code":{},"format":{}}, [2,[7,"/"],[2,[6,"pro"],[2,[1,[2,[7,"/"],[3,"discount_code"]]],[1,[2,[8,"."],[3,"format"]]]]]]);

  /**
   * Generates rails route to
   * /pro/subscriber(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const pro_subscriber_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pro"],[2,[7,"/"],[2,[6,"subscriber"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /profile(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const profile_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /funding(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"funding"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /organizations/:slug_and_id/projects(.:format)
   * @param {any} slug_and_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const projects_organization_path = /*#__PURE__*/ __jsr.r({"slug_and_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"slug_and_id"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /funding/tgo/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const projects_tgo_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"tgo"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /funding/tgo(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const projects_tgo_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"tgo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /rails/info(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const rails_info_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /rails/info/properties(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const rails_info_properties_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /rails/info/routes(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const rails_info_routes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"routes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /jobs/:id/recommended_candidates(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const recommended_candidates_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"recommended_candidates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /recruiter(/*react_route)(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const recruiter_dashboard_path = /*#__PURE__*/ __jsr.r({"react_route":{},"format":{}}, [2,[7,"/"],[2,[6,"recruiter"],[2,[1,[2,[7,"/"],[5,[3,"react_route"]]]],[1,[2,[8,"."],[3,"format"]]]]]]);

  /**
   * Generates rails route to
   * /recruiter/jobs(/*react_route)(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const recruiter_posted_jobs_path = /*#__PURE__*/ __jsr.r({"react_route":{},"format":{}}, [2,[7,"/"],[2,[6,"recruiter"],[2,[7,"/"],[2,[6,"jobs"],[2,[1,[2,[7,"/"],[5,[3,"react_route"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

  /**
   * Generates rails route to
   * /recruiter/search(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const recruiter_search_people_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recruiter"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /recruiting-insight(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const recruiting_insight_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recruiting-insight"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /redirect(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const redirect_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"redirect"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /register(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /jobs/:id/repost(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const repost_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"repost"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /reset_password(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const reset_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reset_password"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /search(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/jobs/search(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const search_admin_development_data_jobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /funding/search/advanced(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const search_advanced_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"advanced"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /funding/search/all(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const search_all_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /funding/search/autocomplete(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const search_autocomplete_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"autocomplete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /jobs/search(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const search_jobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /organizations/search(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const search_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /people/search(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const search_people_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /funding/tgo/search(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const search_projects_tgo_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"tgo"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /organizations/:slug_and_id/secure(.:format)
   * @param {any} slug_and_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const secure_organization_path = /*#__PURE__*/ __jsr.r({"slug_and_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"slug_and_id"],[2,[7,"/"],[2,[6,"secure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /news/sponsored/:slug_and_id(.:format)
   * @param {any} slug_and_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const sponsored_news_article_path = /*#__PURE__*/ __jsr.r({"slug_and_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"sponsored"],[2,[7,"/"],[2,[3,"slug_and_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /news/sponsored/:slug_and_id/amp(.:format)
   * @param {any} slug_and_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const sponsored_news_article_amp_path = /*#__PURE__*/ __jsr.r({"slug_and_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"news"],[2,[7,"/"],[2,[6,"sponsored"],[2,[7,"/"],[2,[3,"slug_and_id"],[2,[7,"/"],[2,[6,"amp"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /organizations/:slug_and_id/staff(.:format)
   * @param {any} slug_and_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const staff_organization_path = /*#__PURE__*/ __jsr.r({"slug_and_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"slug_and_id"],[2,[7,"/"],[2,[6,"staff"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/organizations/state_change(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const state_change_admin_development_data_organizations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"state_change"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /api/public/current_user/payment_pages(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const submit_payment_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"current_user"],[2,[7,"/"],[2,[6,"payment_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /funding/tenders/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const tender_default_projects_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"tenders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /funding/tenders/:permalink/:id(.:format)
   * @param {any} permalink
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const tender_projects_path = /*#__PURE__*/ __jsr.r({"permalink":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"tenders"],[2,[7,"/"],[2,[3,"permalink"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /funding/tenders-grants(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const tgo_index_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"tenders-grants"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /funding/tenders-grants/search(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const tgo_search_projects_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"funding"],[2,[7,"/"],[2,[6,"tenders-grants"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /focus/:identifier(.:format)
   * @param {any} identifier
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const topic_landing_path = /*#__PURE__*/ __jsr.r({"identifier":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"focus"],[2,[7,"/"],[2,[3,"identifier"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /ui_expo/:section(.:format)
   * @param {any} section
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const ui_expo_path = /*#__PURE__*/ __jsr.r({"section":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ui_expo"],[2,[7,"/"],[2,[3,"section"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /ui_expo(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const ui_expo_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ui_expo"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /campaigns/:id/unfollow(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const unfollow_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unfollow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /updates(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const updates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"updates"],[1,[2,[8,"."],[3,"format"]]]]]);

  /**
   * Generates rails route to
   * /upgrade(/*react_route)(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const upgrade_path = /*#__PURE__*/ __jsr.r({"react_route":{},"format":{}}, [2,[7,"/"],[2,[6,"upgrade"],[2,[1,[2,[7,"/"],[5,[3,"react_route"]]]],[1,[2,[8,"."],[3,"format"]]]]]]);

  /**
   * Generates rails route to
   * /membership/:permalink(.:format)
   * @param {any} permalink
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const upgrade_page_path = /*#__PURE__*/ __jsr.r({"permalink":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"membership"],[2,[7,"/"],[2,[3,"permalink"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/contracts/upload(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const upload_admin_development_data_contracts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /admin/development_data/funding_infos/upload(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const upload_admin_development_data_funding_infos_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"development_data"],[2,[7,"/"],[2,[6,"funding_infos"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  /**
   * Generates rails route to
   * /profile/upload_cv(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const upload_cv_profile_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"upload_cv"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /focus/us-aid(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const us_aid_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"focus"],[2,[7,"/"],[2,[6,"us-aid"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /organizations/:slug_and_id/users(.:format)
   * @param {any} slug_and_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const users_organization_path = /*#__PURE__*/ __jsr.r({"slug_and_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"slug_and_id"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  /**
   * Generates rails route to
   * /profile/verify_data(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const verify_data_profile_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"verify_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /account/verify_email_address(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const verify_email_address_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"verify_email_address"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /focus/vision(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const vision_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"focus"],[2,[7,"/"],[2,[6,"vision"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  /**
   * Generates rails route to
   * /zendesk(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export const zendesk_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"zendesk"],[1,[2,[8,"."],[3,"format"]]]]]);

